import LOKIJS from "lokijs";
import axios from "axios";

axios.defaults.withCredentials=true
axios.defaults.crossDomain=true

//补充了citys中的洛杉矶
window.localStorage.removeItem("yc@2020.07.16");
window.localStorage.removeItem("yc@2020.08.12");
window.localStorage.removeItem("yc@2020.08.28");
window.localStorage.removeItem("yc@2020.09.01.test");
window.localStorage.removeItem("yc@2020.09.01");
window.localStorage.removeItem("yc@2020.09.01.v2");

const DB = new LOKIJS("yc@2020.09.03.v1", {
  persistenceMethod: "localStorage"
});

const initDB = async function(success) {
  DB.loadDatabase();
  if (!DB.getCollection("citys")) {
    await initCityTable();
  }
  if (!DB.getCollection("airports")) {
    await initPortTable();
  }
  if (!DB.getCollection("airline")) {
    await initAirlineTable();
  }
  if (!DB.getCollection("imphotdata")) {
    await initImphotdata();
  }
  if (!DB.getCollection("exphotdata")) {
    await initExphotdata();
  }
  if (!DB.getCollection("countryCode")) {
    await initCountryCode();
  }
  !!success && success();
};

// https://doc.yctop.com/yc/static/json-v2/saas_ports.json

const initCityTable = async function() {
  var citys = DB.addCollection("citys", ["cc", "cn", "ctn"], true, false);
  DB.listCollections();
  let { data } = await axios.get(
    // "/oss/yc/static/json-v2/saas_citys.json?t=" + new Date().getTime()
    "//doc.yctop.com/yc/static/json-v2/saas_citys.json?t=" + new Date().getTime()
  );
  for (let c of data) {
    citys.insert(c);
  }
  DB.save();
  console.log("city db finished");
};

const initPortTable = async function() {
  var airports = DB.addCollection(
    "airports",
    ["cc", "cn", "pn", "pc"],
    true,
    false
  );
  DB.listCollections();
  let { data } = await axios.get(
    "//doc.yctop.com/yc/static/json-v2/saas_ports.json?t=" + new Date().getTime()
  );
  for (let c of data) {
    airports.insert(c);
  }
  DB.save();
  console.log("port db finished");
};

const initAirlineTable = async function() {
  var airports = DB.addCollection("airline", ["c", "t"], true, false);
  DB.listCollections();
  let { data } = await axios.get(
    "//doc.yctop.com/yc/static/json-v2/airlines.js?t=" + new Date().getTime()
  );
  for (let c of data) {
    airports.insert(c);
  }
  DB.save();
  console.log("airline db finished");
};

const cityDB = async function() {
  // DB.loadDatabase()
  // if(!DB.getCollection('citys'))
  // 	await initCityTable()
  await initDB();
  return DB.getCollection("citys");
};

const portDB = async function() {
  // DB.loadDatabase()
  // if(!DB.getCollection('airports'))
  // 	await initPortTable()
  await initDB();
  return DB.getCollection("airports");
};

const airlineDB = async function() {
  // DB.loadDatabase()
  // if(!DB.getCollection('airline'))
  // 	await initAirlineTable()
  await initDB();
  return DB.getCollection("airline");
};

const imphotdata = async function() {
  // DB.loadDatabase()
  // if(!DB.getCollection('imphotdata'))
  // 	await initImphotdata()
  await initDB();
  return DB.getCollection("imphotdata");
};
const exphotdata = async function() {
  // DB.loadDatabase()
  // if(!DB.getCollection('exphotdata'))
  // 	await initExphotdata()
  await initDB();
  return DB.getCollection("exphotdata");
};
const countryCode = async function() {
  // DB.loadDatabase()
  // if(!DB.getCollection('countryCode'))
  // 	await initCountryCode()
  await initDB();
  return DB.getCollection("countryCode");
};

const getAirlineZhByCode = async function(query) {
  var AirlineDB = await airlineDB();
  var patt = "^" + query.toUpperCase();
  var reg = new RegExp(patt, "");
  var result = AirlineDB.where(function(obj) {
    return !!reg.test(obj.c);
  });
  for (let item of result) {
    return item.t;
  }
};

const getPortZhByCode = async function(query) {
  var PORTDB = await portDB();
  var patt = "^" + query;
  var reg = new RegExp(patt, "");
  var result = PORTDB.where(function(obj) {
    return reg.test(obj.pc);
  });
  for (let item of result) {
    return item.pn;
  }
};
const getPortCityZhByCode = async function(query) {
  var PORTDB = await portDB();
  var CITYDB = await cityDB();
  var patt = "^" + query;
  var reg = new RegExp(patt, "");
  var cityRes = await CITYDB.where(function(obj) {
    return reg.test(obj.cc);
  });
  if (!!cityRes && cityRes.length > 0) {
    return cityRes[0].cn;
  }
  var result = await PORTDB.where(function(obj) {
    return reg.test(obj.pc);
  });
  for (let item of result) {
    return item.cn;
  }
};
const getCityZhByCode = async function(query) {
  var CITYDB = await cityDB();
  var patt = "^" + query;
  var reg = new RegExp(patt, "");
  var result = CITYDB.where(function(obj) {
    return reg.test(obj.cc);
  });
  for (let item of result) {
    return item.cn;
  }
};
const initImphotdata = async function() {
  var impData = DB.addCollection("imphotdata", ["id", "impname"], true, false);
  DB.listCollections();
  let { data } = await axios.get(
    "//doc.yctop.com/yc/static/json-v2/imphotdata.json?t=" + new Date().getTime()
  );
  for (let c of data) {
    impData.insert(c);
  }
  DB.save();
  console.log("im db finished");
};

const initExphotdata = async function() {
  var expData = DB.addCollection("exphotdata", ["id", "expname"], true, false);
  DB.listCollections();
  let { data } = await axios.get(
    "//doc.yctop.com/yc/static/json-v2/exphotdata.json?t=" + new Date().getTime()
  );
  for (let c of data) {
    expData.insert(c);
  }
  DB.save();
  console.log("ex db finished");
};
const initCountryCode = async function() {
  var countryData = DB.addCollection(
    "countryCode",
    ["Key", "Value", "EnglishName"],
    true,
    false
  );
  DB.listCollections();
  let { data } = await axios.get(
    "//doc.yctop.com/yc/static/json-v2/countryCode.js?t=" + new Date().getTime()
  );
  for (let c of data) {
    countryData.insert(c);
  }
  DB.save();
  console.log("country db finished");
};

const DBUtils = {
  initDB: initDB,
  getDBCitys: cityDB,
  getDBPorts: portDB,
  getDBAirlines: airlineDB,
  getAirlineZhName: getAirlineZhByCode,
  getCityZh: getCityZhByCode,
  getPortZh: getPortZhByCode,
  getImphotdata: imphotdata,
  getExphotdata: exphotdata,
  getCountryCode: countryCode,
  getPortCityName: getPortCityZhByCode
};

export default DBUtils;
